import FeaturedTopic from '@insided/destination/modules/Navigation/widget-featured-topics/FeaturedTopic'
import Search from '../algolia/components/Search'
import { arrayMove, SortableContainer, SortableElement } from 'react-sortable-hoc'
import Switcher from '../control/Switcher'
import globals from '../../utils/globals'
import InputGroup from '../../control-components/ui-components/InputGroup'

const SortableList = SortableContainer(({ children }) => (
  <ul className='sortable-curated-topics-list'>{children}</ul>
))
const SortableItem = SortableElement(({ children }) => (
  <li className='sortable-curated-topic'>{children}</li>
))
const convertFoundTopicToCuratedTopic = (foundTopic) => {
  return {
    id: foundTopic.id,
    title: foundTopic.title,
    url: globals('communityUrl') + foundTopic.topic_url,
    type: foundTopic.content_type
  }
}

const ContentCurationManager = (props) => {
  const { showTitle = false } = props
  return (
    <div className='content-curation-manager'>
      {Boolean(props.description) && <div className='form-group'>{props.description}</div>}
      {Boolean(props.visibilityText) && (
        <div className='form-group'>
          <label>Visibility</label>
          <div className='content-curation-manager_visibility'>
            <div className='clearfix content-curation-manager_visibility-switch'>
              <Switcher
                on={props.enabled}
                label={props.visibilityText}
                onChange={() => props.onUpdate('enabled', !props.enabled)}
              />
            </div>
            {Boolean(props.showCommunityListVisibility) && (
              <div className='clearfix content-curation-manager_visibility-switch'>
                <Switcher
                  on={props.enabledCommunityList}
                  label={props.communityListVisibilityText}
                  onChange={() => {
                    return props.onUpdate('enabledCommunityList', !props.enabledCommunityList)
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {Boolean(showTitle) && (
        <InputGroup
          title='Title'
          qaClasses='qa-content-curation-manager_title'
          type='text'
          onChange={(e) => props.onUpdate('title', e.target.value)}
          value={props.title}
        />
      )}
      <div className='form-group'>
        <label>Topics</label>
        <SortableList
          useDragHandle
          onSortEnd={(result) => {
            const curatedTopics = arrayMove(props.curatedTopics, result.oldIndex, result.newIndex)
            return props.onUpdate('curatedTopics', curatedTopics)
          }}
        >
          {props.curatedTopics.map((curatedTopic, idx) => (
            <SortableItem index={idx} key={curatedTopic.id}>
              <FeaturedTopic
                title={curatedTopic.title}
                url={curatedTopic.url}
                onDelete={() => {
                  const curatedTopics = props.curatedTopics.filter((t) => t !== curatedTopic)
                  return props.onUpdate('curatedTopics', curatedTopics)
                }}
              />
            </SortableItem>
          ))}
          <Search
            isControl
            searchPlaceholder={props.searchPlaceholder}
            callback={(foundTopic) => {
              const curatedTopics = props.curatedTopics.concat([
                convertFoundTopicToCuratedTopic(foundTopic)
              ])
              return props.onUpdate('curatedTopics', curatedTopics)
            }}
            exclude={props.curatedTopics.map((t) => t.id)}
            submitIconType='add'
          />
        </SortableList>
      </div>
    </div>
  )
}

export default ContentCurationManager
